import {z} from 'zod';
import {LabelValueSchema} from '@netx/core-next/schema';

export const ImageProcessSchema = LabelValueSchema.extend({
	id: z.number().int().positive(),
});

export type IImageProcess = z.infer<typeof ImageProcessSchema>;
